<template>
    <div>
        <div class="d-flex justify-content-center" :style="{ gap: '12px' }">
            <div class="d-flex align-items-center" :style="{ gap: '20px' }">
                <div>
                    <el-progress
                        :width="80"
                        type="dashboard"
                        :percentage="percentage"
                        :color="colors"
                    />
                </div>
                <el-input-number
                    v-model="internalValue"
                    placeholder="Ex: 15"
                    :min="0"
                    :max="100"
                    size="mini"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import {
        Progress,
        InputNumber,
    } from "element-ui"

    export default {
        props: {
            value: {
                type: [String, Number],
                default: 0,
            }
        },
        data() {
            return {
                colors: [
                    {color: '#f56c6c', percentage: 20},
                    {color: '#e6a23c', percentage: 40},
                    {color: '#6f7ad3', percentage: 60},
                    {color: '#1989fa', percentage: 80},
                    {color: '#5cb87a', percentage: 100},
                ],
            }
        },
        computed: {
            internalValue: {
                get() {
                    return Number(this.value) || 0;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                }
            },
            percentage() {
                const n = Number(this.value);
                if (Number.isNaN(n)) return 0;
                return Math.min(100, Math.max(0, n));
            }
        },
        components: {
            [Progress.name]: Progress,
            [InputNumber.name]: InputNumber,
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/_micro/Form/FormProgressBarMoon.vue